module.exports = __webpack_public_path__ + "img/2.9beb6611.jpg";